<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.exchange_rate.exchange_rate') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('administration.exchange_rate.exchange_rate'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px"
              class="mr-2"
            />
            <ts-button
              outline
              v-tooltip="$t('filter')"
              @click.prevent="showFilter"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-loading-banner :loading="exporting">
              <Table
                :columns="columns"
                :data="resources"
                :loading="loading"
                max-height="700"
                stripe
                highlight-row
                size="small"
              >
                <template slot-scope="{ row }" slot="branch_name_en">
                  {{ row.branch !== null ? row.branch.branch_name_en : '' }}
                </template>
                <template slot-scope="{ row }" slot="currency_code">
                  {{ row.currency !== null ? row.currency.currency_code : '' }}
                </template>
                <template slot-scope="{ row }" slot="action">
                  <a
                    href="#"
                    v-tooltip="$t('edit')"
                    class="text-primary mr-2"
                    @click.prevent="edit(row)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    href="#"
                    v-tooltip="$t('delete')"
                    class="text-danger"
                    @click.prevent="destroy(row.id)"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </template>
              </Table>
            </ts-loading-banner>
          </div>
          <div class="d-flex justify-content-between align-items-center p-15">
            <ts-total-list v-model="pagination" />
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <ts-loading-banner :loading="waiting_fetch">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <a-select
                    style="width: 257px"
                    v-model="branch_id"
                    :options="branchs"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                    @change="fetchData({ branch_id: branch_id })"
                  >
                  </a-select>
                </div>
              </div>
            </div>
          </ts-loading-banner>
        </a-drawer>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'exchange-rate',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      visible: false,
      exporting: false,
      waiting_fetch: false,
      branchs: []
    }
  },
  mounted() {
    if (!this.$route.params.id) {
      this.branch_id = [this.$store.state.authUser.default_branch_id]
      this.fetchData()
    }
  },
  computed: {
    ...mapState('exchangeRate', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.exchangeRate.search
      },
      set(newVal) {
        this.$store.commit('exchangeRate/SET_SEARCH', newVal)
        this.$store.commit('exchangeRate/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.exchangeRate.branch_id
      },
      set(newValue) {
        this.$store.commit('exchangeRate/SET_BRANCH_ID', newValue)
      }
    },
    columns() {
      return [
        {
          title: this.$t('administration.exchange_rate.branch'),
          slot: 'branch_name_en',
          minWidth: 120
        },
        {
          title: this.$t('administration.exchange_rate.date'),
          key: 'value_date',
          minWidth: 80
        },
        {
          title: this.$t('administration.exchange_rate.currency'),
          slot: 'currency_code',
          minWidth: 60
        },
        {
          title: this.$t('administration.exchange_rate.exchange_rate'),
          key: 'exchange_rate',
          minWidth: 60
        },
        {
          title: this.$t('administration.exchange_rate.buy_rate'),
          key: 'exchange_buy',
          minWidth: 60
        },
        {
          title: this.$t('administration.exchange_rate.sell_rate'),
          key: 'exchange_sell',
          minWidth: 60
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch(
          'exchangeRate/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    async getBranch() {
      return this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit(data) {
      this.edit_data = data
      this.$router.push(`/exchange-rates/${data.id}`)
    },

    async destroy(id) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        this.$store
          .dispatch('exchangeRate/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    async showFilter() {
      this.visible = !this.visible
      if (this.visible) {
        this.waiting_fetch = true
        await this.getBranch()
        this.waiting_fetch = false
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'exchange-rate-create') {
      this.$store.commit('exchangeRate/RESET_STATE')
    }
    next()
  }
}
</script>
